/**
 * TKP-170 md.36 — veri kartı envanter özellikleri panelinin bölüm sırası (kullanıcı listesi):
 * İşleme, Doğrudan Toplama, Diğer Kanallardan Toplama, Fiziksel Saklama, Fiziksel Arşiv, Elektronik Saklama, Elektronik Arşiv,
 * Aktarım, Periyodik İmha Süresi, Periyodik İmha Yöntemi, İdari/Teknik Tedbirler, Erişim Yetki ve Kısıtlamaları,
 * İlgili Kişi Hakları, Otomatik İşleme. Saf: store/Vue yok. Birim/süreç paneli (hierarchy-inventory.js) aynı sırayı kullanır.
 */
export const PANEL_ORDER = [
  "processingLegals",
  "directCollectMethods",
  "otherCollectMethods",
  "physicalStorages",
  "physicalArchives",
  "electronicStorages",
  "electronicArchives",
  "transferings",
  "disposalPeriod",
  "disposalMethods",
  "measures",
  "accessAndRestrictions",
  "datasubjectRights",
  "feature",
];

/** Sabit (düğüm alanı) bölümler: kimlik ve gövde türü eski id'lerle (açık/kapalı durumu ve formlar aynı kalsın). */
export const FIXED = {
  disposalPeriod: { id: "pdip-disposal-period", kind: "period", label: "disposal-method.periodic" },
  disposalMethods: { id: "pdip-disposal-method", kind: "method", label: "disposal-method.text" },
  measures: { id: "pdip-measures", kind: "measures", label: null },
  accessAndRestrictions: { id: "pdip-access", kind: "access", label: "access-restriction.text" },
};

/** Bölüm listelerini PANEL_ORDER sırasına dizer: { id, kind, label, section? }. Tanınmayan anahtar sona düşer. */
export const orderPanelSections = (datasourceSections = [], datasubjectSections = []) => {
  const byKey = {};
  for (const [key, f] of Object.entries(FIXED)) byKey[key] = { key, ...f };
  for (const s of datasourceSections) byKey[s.key] = { key: s.key, id: `pdip-${s.key}`, kind: "datasource", label: s.label, section: s };
  for (const s of datasubjectSections) byKey[s.key] = { key: s.key, id: `pdip-${s.key}`, kind: "datasubject", label: s.label, section: s };
  const ordered = PANEL_ORDER.filter((k) => byKey[k]).map((k) => byKey[k]);
  const rest = Object.keys(byKey).filter((k) => !PANEL_ORDER.includes(k)).map((k) => byKey[k]);
  return [...ordered, ...rest];
};
